import { Skeleton } from '@mantine/core';
import React from 'react';

function XSkeletonLoadingTableBody(props: Props) {
  const { numColumns } = props;

  return (
    <>
      <tbody>
        <tr>
          {[...Array(numColumns)].map((_, index) => {
            return (
              <>
                <td key={index}>
                  <Skeleton height={14} width='100%' />
                </td>
              </>
            );
          })}
        </tr>
        <tr>
          {[...Array(numColumns)].map((_, index) => {
            return (
              <>
                <td key={index}>
                  <Skeleton height={14} width='100%' />
                </td>
              </>
            );
          })}
        </tr>
        <tr>
          {[...Array(numColumns)].map((_, index) => {
            return (
              <>
                <td key={index}>
                  <Skeleton height={14} width='100%' />
                </td>
              </>
            );
          })}
        </tr>
        <tr>
          {[...Array(numColumns)].map((_, index) => {
            return (
              <>
                <td key={index}>
                  <Skeleton height={14} width='100%' />
                </td>
              </>
            );
          })}
        </tr>
      </tbody>
    </>
  );
}

interface Props {
  numColumns: number;
}
export default XSkeletonLoadingTableBody;
